export default class Gate{

    constructor(user){
        this.user = user;
    }

    isAdmin(){
        //console.log(this.user);
        return  1;
       //return this.user.role === 1;
    }

    isDev(){
        return this.user && this.user.rolename === 'dev';
    }

    isUser(){
        return this.user && this.user.rolename === 'user';
    }

}

